import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';
import { Icon } from '../../components/shared';
import { WidgetContext } from './WidgetContext';
import WidgetMembershipDetail from './WidgetMembershipDetail';

const WidgetMemberships = () => {
  const { t } = useTranslation();
  const { memberships, primaryColor } = useContext(WidgetContext);

  // Use custom primary color if available, otherwise fallback to default mandy color
  const primary = primaryColor || 'var(--feel-primary)';
  const [openedMembershipId, setOpenedMembershipId] = useState(false);
  const [selectedMembership, setSelectedMembership] = useState(0);
  const [showMobileContent, setShowMobileContent] = useState(false);

  if (!memberships?.length) {
    return null;
  }

  const selectedService = memberships[selectedMembership];

  return (
    <div className="w-full">
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Sidebar - Memberships list */}
        <div className={`lg:w-80 flex-shrink-0 ${showMobileContent ? 'hidden lg:block' : 'block'}`}>
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6">
            <h3 className="text-lg font-semibold mb-4 flex items-center" style={{ color: colors.mineShaft }}>
              <Icon name="book" size="sm" className="mr-2" style={{ color: primary }} />
              {t('MEMBERSHIPS.title')}
            </h3>
            <div className="space-y-2">
              {memberships.map((membership, idx) => (
                <button
                  key={membership.id}
                  onClick={() => {
                    setSelectedMembership(idx);
                    setShowMobileContent(true);
                  }}
                  className={`w-full text-left px-4 py-3 rounded-lg transition-all duration-200 flex items-center justify-between ${
                    selectedMembership === idx ? `text-white shadow-lg` : `text-gray-600 hover:text-white hover:shadow-lg`
                  }`}
                  style={{
                    backgroundColor: selectedMembership === idx ? primary : 'transparent',
                  }}
                  onMouseEnter={e => {
                    if (selectedMembership !== idx) {
                      e.currentTarget.style.backgroundColor = primary;
                    }
                  }}
                  onMouseLeave={e => {
                    if (selectedMembership !== idx) {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }
                  }}
                >
                  <span className="font-medium truncate">{membership.name}</span>
                  <span
                    className={`text-sm px-2 py-1 rounded-full transition-all duration-200 ${
                      selectedMembership === idx ? 'bg-white bg-opacity-20 text-white' : 'bg-gray-100 text-gray-600'
                    }`}
                  >
                    {membership?.offers?.length || 0}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className={`flex-1 ${!showMobileContent ? 'hidden lg:block' : 'block'}`}>
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-4 lg:p-6 mb-4 lg:mb-6">
            <div className="flex items-center">
              {/* Mobile Back Button */}
              <button
                onClick={() => setShowMobileContent(false)}
                className="lg:hidden mr-3 p-1.5 rounded-lg hover:bg-gray-100 transition-colors duration-200"
              >
                <Icon name="arrow-left" size="sm" className="text-gray-600" />
              </button>

              <div className="p-2 lg:p-3 rounded-full mr-3 lg:mr-4" style={{ backgroundColor: primary + '1A' }}>
                <Icon name="book" size="md" className="lg:size-lg" style={{ color: primary }} />
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="text-lg lg:text-2xl font-bold text-gray-900 mb-0.5 lg:mb-1 truncate">{selectedService ? selectedService.name : ''}</h2>
                <p className="text-sm lg:text-base text-gray-600 hidden sm:block">{t('WIDGET.membershipsDescription')}</p>
              </div>
            </div>
          </div>

          {/* Cards grid */}
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2 w-full">
            {selectedService?.offers?.map(offer => (
              <WidgetMembershipDetail
                key={offer.id}
                membership={offer}
                openedMembershipId={openedMembershipId}
                setOpenedMembershipId={setOpenedMembershipId}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidgetMemberships;
